import {
  getMinutesInHourAndMinutesStr,
} from "../../util";
import PickupDeliveryPopupRenderer from "./PickupDeliveryPopupRenderer";
import constants from "./constants";
const PendingStopOnTimePopup = ({ task }) => {
  return (
    <PickupDeliveryPopupRenderer
      stopType={task?.data?.stopType}
      arrivalTimeLabel={constants.POPUP_LABELS.EST_ARRIVAL_TIME}
      arrivalTime={task.arrivalTime}
      departureTimeLabel={constants.POPUP_LABELS.EST_DEPARTURE_TIME}
      departureTime={task.departureTime}
      stopTime={getMinutesInHourAndMinutesStr(task.stopDuration)}
      stopTimeLabel={constants.POPUP_LABELS.EST_STOP_TIME}
      statusLabel={constants.POPUP_LABELS.STATUS}
      statusValue="On Time"
      stopStatusClass="noViolation"
      serviceWindow={task?.data}
      stopData={task.data}
    />
  );
};

export default PendingStopOnTimePopup;
